<script>
import { styleState } from "@app/store/styleStore.svelte.js";
import { projectState } from "@app/store/projectStore.svelte.js";
import { eventGroupState } from "@app/store/eventGroupStore.svelte.js";
import { insertHistoryAction } from "@app/store/historyStore.svelte.js";
import { normalizeEventYPosition } from "@app/lib/eventPosition.js";
import * as m from '@app/paraglide/messages.js';

function moveDownOneLine() {
    // Get current event group's display dimensions
    const displayHeight = styleState.height || 15;

    eventGroupState[projectState.selected].selected.forEach((evIndex) => {
        try {
            let currentY;

            // Get current Y position (line number)
            if (
                typeof eventGroupState[projectState.selected].events[evIndex]
                    .yPos === "number"
            ) {
                currentY =
                    eventGroupState[projectState.selected].events[evIndex].yPos;
            } else {
                // Convert string position to number
                switch (
                    eventGroupState[projectState.selected].events[evIndex].yPos
                ) {
                    case "start":
                        currentY = 1;
                        break;
                    case "center":
                        currentY = Math.floor(displayHeight / 2);
                        break;
                    case "end":
                        currentY = displayHeight;
                        break;
                    default:
                        currentY = displayHeight; // Default to bottom
                }
            }

            // Move down one line (add 1), but don't go above displayHeight
            const newY = Math.min(displayHeight, currentY + 1);
            const event = eventGroupState[projectState.selected].events[evIndex];
            event.yPos = normalizeEventYPosition(event, newY, displayHeight);
        } catch (err) {
            console.error("Position line down error");
            console.error(err.message);
            console.log(err);
        }
    });

    insertHistoryAction({
        name: "position line down", //action name
        eventGroup: projectState.selected,
        snapshots: [
            {
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState),
            },
        ],
    });
}
</script>

<li class="nav-item" title={m.position_line_down_title()}>
    <a
        class="nav-link"
        href="#!/"
        role="button"
        id="position-line-down-btn"
        aria-label={m.position_line_down_aria_label()}
        class:disabled={!eventGroupState[projectState.selected] ||
            eventGroupState[projectState.selected].selected.length === 0}
        aria-disabled={!eventGroupState[projectState.selected] ||
            eventGroupState[projectState.selected].selected.length === 0}
        onclick={moveDownOneLine}>
        <i class="bi bi-chevron-down" aria-hidden="true"></i>
    </a>
</li>
